// extracted by mini-css-extract-plugin
export default {"divider_wrapper":"Divider_divider_wrapper__AF+9P","divider":"Divider_divider__L5i6i"};